import React, { FunctionComponent } from 'react';

import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ErrorDisplay } from 'social/publisher/error-display/ErrorDisplay';
import { PublisherError } from 'social/publisher/Publisher.types';
import { usePublisherDispatch } from 'social/publisher/PublisherContext';

import 'social/publisher/title-editor/TitleEditor.scss';

interface Props {
    title: string | undefined;
    publisherErrors: PublisherError[];
    isYoutube: boolean;
}

export const TitleEditor: FunctionComponent<Props> = ({ title, publisherErrors, isYoutube }) => {
    const dispatch = usePublisherDispatch();
    const { t } = useTranslation(['social/publisher']);
    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        dispatch({ type: 'set-title', payload: { value: e.target.value } });
        const titleError = publisherErrors.filter((el) => el.component === 'TITLE');

        if (titleError) {
            // Resets title errors
            dispatch({ type: 'remove-publisher-errors-by-component', payload: { value: 'TITLE' } });
        }
    };

    return (
        <div className="r4e-social-title-editor">
            <h3 className="title-editor-title">{t('TITLE')}</h3>
            <ErrorDisplay component="TITLE" publisherErrors={publisherErrors} />
            <Form>
                <Form.Group controlId="formContentTitle">
                    <Form.Control type="text" autoComplete="off" value={title} onChange={handleTitleChange} />
                </Form.Group>
            </Form>
        </div>
    );
};
